import sanitizeHtml from "sanitize-html";

type SanitizeOptions = {
  addAttributes?: string[];
};

/**
 * Sanitizes HTML content.
 *
 * Uses sanitize-html (pure JS, no DOM dependency) on both server and client.
 * Because it is a deterministic string transform, the output is byte-identical
 * in Node and in the browser — this is required to avoid SSR hydration
 * mismatches. Do NOT branch on `typeof window` with a different sanitizer:
 * divergent output is React's hydration-failure cause #1.
 */
export const sanitize = (html: string, options?: SanitizeOptions): string => {
  return sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      "img",
      "h1",
      "h2",
      "span",
    ]),
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      "*": ["class", "style", ...(options?.addAttributes ?? [])],
      a: ["href", "name", "target", "rel"],
      img: ["src", "alt", "title", "width", "height"],
    },
  });
};
